export const UPDATE_PROCESS_STATEMENT_COMMENT_REQUEST = 'UPDATE_PROCESS_STATEMENT_COMMENT_REQUEST';

export const updateProcessStatementCommentRequest = (processStatementId, processStatementComment) => ({
  type   : UPDATE_PROCESS_STATEMENT_COMMENT_REQUEST,
  payload: {
    processStatementId,
    processStatementComment
  }
});
